/* eslint-disable no-self-assign */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Global } from '../shared/global';
import { catchError, map, retry } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { NotifyService } from '../services/notify.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    authorizationData = 'Basic ' + btoa(Global.PPAAuthHeaderName + ':' + Global.PPAAuthHeaderValue);
    ppaAuthHeaderName: string  = Global.PPAAuthHeaderName;
    constructor(
        private authenticationService: AuthenticationService,
        public notifyService: NotifyService,
        private router: Router,
        private toastr: ToastrService,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let url: string = request.url;
        let userId = null;
        let isEmbedded = false;
        
        if (sessionStorage.getItem('currentUser')) {
            let currentUser = JSON.parse(sessionStorage.getItem('currentUser')!);
            // Check if this is embedded mode
            isEmbedded = sessionStorage.getItem('isEmbedded') === 'true';
            // Only set userId if not in embedded mode or if it's a real user
            if (!isEmbedded || currentUser?.userid !== 0) {
                userId = currentUser?.userid.toString();
            }
        }
        // if (url.includes('VIN_Check')) {
        //     request = request.clone({
        //         setHeaders: {
        //             'Content-Type': 'application/json',
        //             'Accept': '*/*',
        //             'DLMSAuth' : Global.PPAAuthHeaderValue,
        //             'Authorization': this.authorizationData
        //             // 'X-API-KEY': Global.Apikey
        //         },
        //     });
        // }
        // else {
        //     if (url.includes("authorize.net")) {
        //         request = request
        //     }else{
        //         request = request.clone({
        //             setHeaders: {
        //                 'Content-Type': 'application/json',
        //                 'Accept': 'application/json',
        //                 'Authorization': Global.AuthToken
        //                 // 'X-API-KEY': Global.Apikey
        //             },
        //         });
        //     }
        // }
        if (url.includes("authorize.net")) {
            request = request
        } else if (request.body instanceof FormData) {
            // Explicitly DELETE Content-Type so browser sets multipart/form-data with boundary
            console.log('[AuthInterceptor] FormData detected — skipping Content-Type');
            if (userId) {
                request = request.clone({
                    headers: request.headers
                        .delete('Content-Type')
                        .delete('Accept')
                        .set('Authorization', Global.AuthToken)
                        .set('UserId', userId)
                });
            } else {
                request = request.clone({
                    headers: request.headers
                        .delete('Content-Type')
                        .delete('Accept')
                        .set('Authorization', Global.AuthToken)
                });
            }
        } else {
            if (userId) {
                request = request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': Global.AuthToken,
                        'UserId': userId
                        // 'X-API-KEY': Global.Apikey
                    },
                });
            } else {
                request = request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': Global.AuthToken
                        // 'X-API-KEY': Global.Apikey
                    },
                });
            }
        }
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                // if (event instanceof HttpResponse) {
                //     console.log('event--->>>', event);
                // }
                return event;
            }),
            retry(1),
            catchError((error: HttpErrorResponse) => {
                return throwError(error);
            })
            );
    }
}